// Burgundy Professional design
const BurgundyProfessionalDesign = {
  id: 'burgundy-professional',
  name: 'Burgundy',
  category: 'professional',
  description: 'Rich burgundy and warm greys for an elegant look',
  colors: {
    primary: "#800020",    // Burgundy
    secondary: "#A0522D",  // Sienna (complementary warm tone)
    tertiary: "#D2B48C",   // Tan
    quaternary: "#F5F5DC", // Beige (very light)
    accent1: "#800020",    // Burgundy
    accent2: "#A0522D",    // Sienna
    // Add other accents if needed
    text: "#5D4037",       // Dark Brown/Grey Text
    textSecondary: "#8D6E63", // Medium Brown/Grey Secondary Text
    background: "#ffffff", // White background
    sidebarBackground: "#F5F5DC", // Beige sidebar
    border: "#ffffff"     // Tan border
  },
};

export default BurgundyProfessionalDesign; 